import "./Branches.css";
import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBranchData } from "../../../redux/slices/branchSlice";
import {
  commonSaveData,
  initCommonState,
} from "../../../redux/slices/commonSlice";
import { deleteBranchPath } from "../../../services/config";
import { geolocationStatus } from "../../../services/commonServices";
import { AgGridReact } from "ag-grid-react";
import { Modal } from "react-bootstrap";
import { PiPencilSimpleLineBold } from "react-icons/pi";
import { RiDeleteBinLine } from "react-icons/ri";
import { ToastContainer, toast } from "react-toastify";

import BranchMap from "./BranchMap";
import { Link } from "react-router-dom";
// icons
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ButtonCom from "../../../components/button/button";
import AddIcon from "@mui/icons-material/Add";
// MUI --------------------
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Widgets from "../../../components/Widgets";
import WidgetsIcon from "../../../components/Widgets/icon";
import CustomPagination from "../../../components/CustomPagination";
import { HasPermission } from "../../../services/hasPermission";
import { useGlobalToast } from "../../../stopOldToastGlobally.js";

const paginationPageSize = 10;

const Branch = () => {
  const [mapStatus, setMapStatus] = useState("");
  const dispatch = useDispatch();
  const state = useSelector((state) => state.branch);
  const commonState = useSelector((state) => state.common);
  const user = JSON.parse(localStorage.getItem("user_data")) || {};
  const toast = useGlobalToast();
  // Variable -----------------------------------
  const [branches, setBranches] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editingData, setEditingData] = useState(null);
  const [gridApi, setGridApi] = useState(null);
  const [locationError, setLocationError] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  // Functions -----------------------------------
  const getBranchList = useCallback(() => {
    dispatch(fetchBranchData());
  }, [dispatch]);

  const getMapStatus = async () => {
    try {
      let res = await geolocationStatus();
      setMapStatus(res);
    } catch (error) {
      console.error("Error getting map status:", error);
      setMapStatus("denied");
    }
  };

  useEffect(() => {
    getMapStatus();
    getBranchList();
  }, [getBranchList]);

  useEffect(() => {
    if (state.brnGetSuccess) {
      // Validate branch data before setting
      const validBranches = (state.brnGetData || []).map(branch => ({
        ...branch,
        // Ensure coordinates are valid numbers
        latitude: branch.latitude ? parseFloat(branch.latitude) : null,
        longitude: branch.longitude ? parseFloat(branch.longitude) : null
      }));
      setBranches(validBranches);
      
      if (gridApi) {
        setTimeout(() => {
          gridApi.sizeColumnsToFit();
        }, 100);
      }
    }
  }, [state, gridApi]);
  // Dialog functions for create new branch  ---------------------------------------------

  const [showMapStatus, setShowMapStatus] = useState(false);
  const [mapStatusMsg, setMapStatusMsg] = useState("");

  const handleOpenDialog = async () => {
    try {
      setLocationError(null);
      
      // Check current location status
      const currentStatus = await geolocationStatus();
      setMapStatus(currentStatus);
      
      if (currentStatus === "granted") {
        // Location is already enabled, open dialog directly
        setOpenDialog(true);
      } else if (currentStatus === "prompt") {
        // Browser hasn't asked for permission yet, request it
        try {
          // Request location permission with better error handling
          navigator.geolocation.getCurrentPosition(
            (position) => {
              // Permission granted
              setMapStatus("granted");
              setOpenDialog(true);
            },
            (error) => {
              // Permission denied or error
              console.error("Geolocation error:", error);
              if (error.code === error.PERMISSION_DENIED) {
                setShowMapStatus(true);
                setMapStatusMsg("Location access denied. Please enable location to add a new branch.");
              } else if (error.code === error.POSITION_UNAVAILABLE) {
                setShowMapStatus(true);
                setMapStatusMsg("Location information is unavailable. Please try again.");
              } else if (error.code === error.TIMEOUT) {
                setShowMapStatus(true);
                setMapStatusMsg("Location request timed out. Please try again.");
              } else {
                setShowMapStatus(true);
                setMapStatusMsg("Unable to get your location. Please enable location services.");
              }
            },
            { 
              timeout: 10000,
              maximumAge: 0,
              enableHighAccuracy: true
            }
          );
        } catch (error) {
          console.error("Error requesting location:", error);
          setShowMapStatus(true);
          setMapStatusMsg("Error accessing location. Please enable location services.");
        }
      } else if (currentStatus === "denied") {
        // Location is blocked, show instruction to unblock
        setShowMapStatus(true);
        setMapStatusMsg(
          "Location access is blocked. Please enable location in your browser settings to add a new branch."
        );
      }
    } catch (error) {
      console.error("Error in handleOpenDialog:", error);
      setShowMapStatus(true);
      setMapStatusMsg("An error occurred. Please try again.");
    }
  };

  const closeLocationStatus = () => {
    setShowMapStatus(false);
    setMapStatusMsg("");
  };
  
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setIsEdit(false);
    setEditingData(null);
    setLocationError(null);
  };
  
  // Create Branch Functions -------------------
  //Edit Function -----------------------------
  const handleEdit = (data) => {
    // Validate edit data before opening
    if (data) {
      setIsEdit(true);
      setEditingData(data);
      handleOpenDialog();
    }
  };

  const actionsDone = (isSuccess, msg) => {
    setIsEdit(false);
    setEditingData(null);
    if (isSuccess) {
      toast.success(msg);
    } else {
      toast.error(msg);
    }
    getBranchList();
    handleCloseDialog();
  };

  // functions for delete records
  const [show, setShow] = useState(false);
  const [brnId, setBrnId] = useState(null);

  const handleModalClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleDelete = (data) => {
    if (data && data.branchId) {
      setBrnId(data.branchId);
      handleShow();
    }
  };

  const handleDeleteSubmit = () => {
    if (brnId && user.user_id) {
      let d = {
        path: deleteBranchPath,
        data: {
          userId: user.user_id,
          branchId: brnId,
        },
      };
      dispatch(commonSaveData(d));
      handleModalClose();
    }
  };

  useEffect(() => {
    if (commonState.commonSuccess || commonState.commonError) {
      if (commonState.commonSuccess) {
        toast.success(commonState.commonMessage);
      } else if (commonState.commonError) {
        toast.error(commonState.commonMessage);
      }
      setBrnId(null);
      dispatch(initCommonState());
      getBranchList();
      handleModalClose();
    }
  }, [commonState.commonSuccess, commonState.commonError, dispatch, getBranchList]);

  // Custom cell renderer for serial number
  const SerialNumberCellRenderer = (props) => {
    return (
      <div className="serial-number-cell" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        fontWeight: '500'
      }}>
        {props.node.rowIndex + 1}
      </div>
    );
  };

  // Custom cell renderer for address column
  const AddressCellRenderer = (props) => {
    return (
      <div className="address-cell-wrapper">
        <div className="address-text">
          {props.value || 'N/A'}
        </div>
      </div>
    );
  };

  const columns = [
    { 
      headerName: "S.No", 
      field: "serialNumber",
      width: 80,
      minWidth: 70,
      maxWidth: 100,
      cellRenderer: SerialNumberCellRenderer,
      cellStyle: { 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: '500'
      },
      sortable: false,
      filter: false,
      resizable: false,
      pinned: 'left'
    },
    { 
      headerName: "Branch Name", 
      field: "branch_name", 
      flex: 1,
      minWidth: 150,
      cellStyle: { 
        display: 'flex',
        alignItems: 'center'
      }
    },
    { 
      headerName: "Radius", 
      field: "radius",
      width: 100,
      minWidth: 80,
      maxWidth: 120,
      cellStyle: { 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      cellRenderer: (params) => {
        return (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%'
          }}>
            {params.value || 'N/A'}
          </div>
        );
      }
    },
    {
      headerName: "Address",
      field: "branch_address",
      flex: 3,
      minWidth: 300,
      autoHeight: true,
      wrapText: true,
      cellRenderer: AddressCellRenderer,
      cellStyle: { 
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        lineHeight: '1.5',
        display: 'flex',
        alignItems: 'flex-start',
        paddingTop: '10px',
        paddingBottom: '10px'
      }
    },
    {
      headerName: "Action",
      field: "id",
      width: 140,
      minWidth: 130,
      maxWidth: 150,
      cellRenderer: (rowData) => {
        const hasEditPermission = HasPermission("Branchs", "edit");
        const hasDeletePermission = HasPermission("Branchs", "delete");
        
        return (
          <div className="Branches-table-button">
            {hasEditPermission && (
              <PiPencilSimpleLineBold
                onClick={() => handleEdit(rowData.data)}
                style={{ cursor: "pointer", fontSize: 30, marginRight: "10px" }}
                className="edit-icon"
              />
            )}
            {hasDeletePermission && (
              <RiDeleteBinLine 
                className="delete-icon"
                onClick={() => handleDelete(rowData.data)}
                style={{ cursor: "pointer", fontSize: 30, color: "red" }}
              />
            )}
            {!hasEditPermission && !hasDeletePermission && "-"}
          </div>
        );
      },
      cellStyle: { 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      sortable: false,
      filter: false,
      pinned: 'right'
    },
  ];

  // Default column definition
  const defaultColDef = {
    resizable: true,
    sortable: true,
    filter: true,
    wrapText: true,
    autoHeight: true,
    cellStyle: { 
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      lineHeight: '1.5'
    }
  };

  return (
    <div
      className="branch-section"
      style={{
        position: "fixed",
        width: "calc(100%)",
        height: "100%",
        borderRadius: "7px",
        overflow: "auto",
        backgroundColor: "transparent",
      }}
    >
      <div className="branch-container">
        <Widgets
          icon={
            <WidgetsIcon
              icon={
                <Link to="/setting/" className="icon-color">
                  <ArrowBackIcon />
                </Link>
              }
              title="Company Branches"
            />
          }
          button={
            HasPermission("Branchs", "create") && (
              <ButtonCom
                type="button"
                class_name="universal-btn border-radius-8px"
                text={"Add New Branch"}
                url_or_onclick={handleOpenDialog}
                icon={<AddIcon />}
                width={""}
              />
            )
          }
          body={
            <>
              <div
                className="ag-theme-quartz custom-grid"
                style={{ 
                  height: "calc(100vh - 230px)", 
                  width: "100%"
                }}
              >
                <AgGridReact
                  rowData={Array.isArray(branches) ? branches : []}
                  columnDefs={columns}
                  defaultColDef={defaultColDef}
                  pagination
                  paginationPageSize={paginationPageSize}
                  onGridReady={onGridReady}
                  onFirstDataRendered={(params) => {
                    params.api.sizeColumnsToFit();
                  }}
                  getRowHeight={(params) => {
                    // Calculate row height based on address length
                    if (params.data && params.data.branch_address) {
                      const addressLength = params.data.branch_address.length;
                      if (addressLength > 100) {
                        return 80;
                      } else if (addressLength > 50) {
                        return 60;
                      }
                    }
                    return 48; // default height
                  }}
                />
              </div>
              <div className="d-flex align-items-center justify-content-between custom-pagination">
                {gridApi && <CustomPagination gridApi={gridApi} />}
              </div>
            </>
          }
        />
      </div>

      <Dialog
        fullScreen={false}
        fullWidth={true}
        maxWidth={"md"}
        open={openDialog}
        onClose={handleCloseDialog}
      >
        {/* Map is rendering here */}
        <BranchMap
          isEdit={isEdit}
          editingData={editingData}
          actionsDone={actionsDone}
          handleCloseDialog={handleCloseDialog}
        />
      </Dialog>

      <Modal show={show} onHide={handleModalClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Delete Branch</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure! to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            style={{
              backgroundColor: "gray",
              color: "#fff",
              marginRight: "10px",
            }}
            onClick={handleModalClose}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            style={{ backgroundColor: "red", color: "#fff" }}
            onClick={handleDeleteSubmit}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Enhanced Location Permission Modal */}
      <Modal
        show={showMapStatus}
        onHide={closeLocationStatus}
        backdrop="static"
        centered
      >
        <Modal.Header 
          closeButton
          style={{
            borderBottom: '2px solid #e0e0e0',
            padding: '20px'
          }}
        >
          <Modal.Title style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ fontSize: '24px' }}>📍</span>
            Location Permission Required
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '20px', fontSize: '15px', lineHeight: '1.6' }}>
          {mapStatusMsg}
          <div style={{
            marginTop: '15px',
            padding: '12px',
            backgroundColor: '#f0f7ff',
            borderRadius: '8px',
            fontSize: '14px',
            color: '#0066cc'
          }}>
            <strong>💡 Tip:</strong> To enable location, click the location icon in your browser's address bar.
          </div>
        </Modal.Body>
        <Modal.Footer style={{ borderTop: '2px solid #e0e0e0', padding: '15px' }}>
          <Button
            style={{ 
              backgroundColor: "#6366f1", 
              color: "#fff",
              padding: '10px 24px',
              borderRadius: '8px',
              border: 'none',
              fontWeight: '600'
            }}
            onClick={closeLocationStatus}
          >
            Got it
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />
    </div>
  );
};

export default Branch;